import React from 'react'
import styles from './index.module.css'

export const LineShop = () => {

  return (
    <div className={styles.LsCon}>
      <h1>Line Shop</h1>
      <div>
        <a href='https://us-central1-jesyka-em.cloudfunctions.net/email?to=macakivo@gmail.com&amp;subject=Test1&amp;text=Text'>Odeslat</a>
      </div>
    </div>
  )
}
